<template>
  <div>
    <div
      class="tw-flex tw-flex-col tw-mx-auto"
      style="max-width: 768px"
    >
      <h2 class="question-title-v2 tw-mb-4 tw-text-white">
        {{ question.title }}
      </h2>
      <div class="tw-mt-4 tw-mb-4">
        <div
          v-for="item in question.displayArray"
          :key="item.id"
          class="tw-flex tw-items-center tw-mb-4"
        >
          <div class="display-bullet"></div>
          <p class="sub-text tw-text-white tw-mb-0 tw-ml-4">
            {{ item.name }}
          </p>
        </div>
      </div>
      <p class="sub-text group-mb tw-mb-6 tw-text-white">
        {{ question.question }}
      </p>
      <div class="cancel-membership">
        <b-button
          class="tw-px-6"
          variant="info"
          size="lg"
          @click="onSubmit"
        >
          {{ question.answerlist[0].name }}
        </b-button>
        <div class="tw-mt-6 tw-pt-1">
          <a
            href="javascript:void(0)"
            class="text-underline text-uppercase tw-text-white"
            style="letter-spacing: 0.1rem"
          >
            Cancel membership
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    question: { type: Object, required: true },
  },
  methods: {
    onSubmit() {
      const a = this.question.answerlist[0];
      this.$emit('submitAnswer', { id: this.question.id, answer: a.id, answerBody: a });
    },
  },
};
</script>

<style scoped>
.display-bullet {
  width: 50px;
  height: 50px;
  background-color: #cdfcb1;
  border-radius: 999px;
}
.cancel-membership {
  display: flex;
  flex-direction: column;
  max-width: 250px;
  align-items: center;
}
</style>
